//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import { Box, useTheme } from '@mui/material'
import { Navigate, Route, Routes } from 'react-router-dom'
import PoolCreateForm from '@react/admin/PoolCreateForm'
import { TopAppBar } from '@react/topbar/TopAppBar'

import { LicenseInfo } from '@mui/x-license-pro'
import BorrowerPoolDetails from './BorrowerPoolDetails'
import BorrowerPoolList from './BorrowerPoolList'

import DemoManagement from '@react/admin/DemoManagement'
import AdminCompanyProfileList from '@react/admin/AdminCompanyProfileList'
import CompanyProfileView from '@react/admin/CompanyProfileView'

import WidthLimited from '@react/components/WidthLimited'
import ReportingPage from '@react/reporting/ReportingPage'
import Width1200 from '@react/components/Width1200'
LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

export default function BorrowerRouting(): React.ReactElement {
  const theme = useTheme()

  return (
    <Box sx={{ height: '100vh', width: '100%', backgroundColor: theme.palette.background.canvas, overflow: 'scroll' }}>
      <TopAppBar></TopAppBar>

      <Routes>
        <Route
          path="/"
          element={
            <Width1200>
              <BorrowerPoolList />
            </Width1200>
          }
        />

        <Route
          path="/reports"
          element={
            <Box data-testid="AdminRountBox2" sx={{ margin: 'auto', marginTop: 3, height: '100vh', maxWidth: '100%' }}>
              <ReportingPage />
            </Box>
          }
        />
        <Route
          path="/pools"
          element={
            <Width1200>
              <BorrowerPoolList />
            </Width1200>
          }
        />
        <Route
          path="/"
          element={
            <WidthLimited>
              <PoolCreateForm></PoolCreateForm>
            </WidthLimited>
          }
        />
        <Route
          path="/demo"
          element={
            <WidthLimited>
              <DemoManagement />
            </WidthLimited>
          }
        />
        <Route
          path="/pools/:poolAddr"
          element={
            <Width1200>
              <BorrowerPoolDetails />
            </Width1200>
          }
        />
        <Route path="/companyProfiles" element={<AdminCompanyProfileList />} />
        <Route path="/companyProfiles/:uuid" element={<CompanyProfileView />} />
        <Route path="/settings" element={<WidthLimited>Settings</WidthLimited>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  )
}
